<form [formGroup]="catchFormGroup" style="height: 100%; padding: 24px;">

  <div *ngIf="!weightsSection" style="display: flex; flex-direction: column; height: 100%;">
    <div class="row">
      <h2>Catch Species</h2>
    </div>

    <!-- Search for species -->
    <div class="row">
      <mat-form-field id="speciesField" #speciesField>
        <mat-label>Species</mat-label>
        <input matInput #speciesInput id="speciesInput" formControlName="species" [matAutocomplete]="auto" required>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="removeFocus(speciesField, speciesInput)" #autocomplete>
          <mat-option *ngFor="let option of filteredSpecies | async"
                      [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="catchFormGroup.get('species')?.hasError('speciesInvalid')">
          Please select a valid species
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Favorite species -->
    <div class="row">

      <h3>
        Favorite Species
      </h3>

      <mat-chip-listbox hideSingleSelectionIndicator="true">
        <mat-chip-option selected
                  *ngFor="let fs of favoriteSpecies"
                  class="species-list"
                  (click)="quickSelect(fs)">
                  <span style="font-size: larger;">{{fs.name}}</span>
        </mat-chip-option>
        <mat-chip-option selected
                  class="add-species-btn"
                  (click)="addSpecies()">
                  <div style="display: flex; align-items: center;">
                    <mat-icon>
                      add
                    </mat-icon>
                    <span style="font-size: larger;">Add species</span>
                  </div>
          
        </mat-chip-option>
      </mat-chip-listbox>

      <mat-divider style="margin-top: 10px; margin-bottom: 10px;">

      </mat-divider>

    </div>

    <!-- Previous species -->
    <div class="row"
         *ngIf="previousSpecies.length > 0">

      <h3>
        Previous Species
      </h3>

      <mat-chip-listbox hideSingleSelectionIndicator="true">
        <mat-chip-option selected
                         *ngFor="let ps of previousSpecies"
                         class="species-list"
                         (click)="quickSelect(ps)">
          <span style="font-size: larger;">{{ps}}</span>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>


    <!-- Delete catch or continue -->
    <div style="display: flex; justify-content: space-between; margin-top: auto; padding-top: 10px;">

      <button mat-fab
              class="text-blue-button"
              type="button"
              (click)="dialogRef.close()">
        Cancel
      </button>



      <button mat-fab
              class="text-button"
              type="button"
              (click)="confirmSpecies()">
        OK
      </button>

    </div>

  </div>


  <div *ngIf="weightsSection" class="container" style="display: flex; flex-direction: column; height: 100%;">
    <h1 class="display-5">{{speciesName}}</h1>

    <div class="row" style="border: 1px solid; border-radius: 5px; padding: 5px;">
      <h2 style="margin-bottom: 0%;">Retained</h2>
      <mat-form-field>
        <mat-label>Piece Count</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="retainedCount" (input)="_forbidNonNumeric(catchFormGroup.get('retainedCount')!)">
        <mat-error *ngIf="catchFormGroup.get('retainedCount')?.hasError('required') && catchFormGroup.get('retainedCount')?.touched"> Required </mat-error>
        <mat-error *ngIf="catchFormGroup.get('retainedCount')?.hasError('min')"> Piece count cannot be less than 0. </mat-error>
        <mat-error *ngIf="catchFormGroup.get('retainedCount')?.hasError('max')"> Piece count cannot be more than 3000. </mat-error>
      </mat-form-field>

      <mat-form-field style="font-weight: bold;">
        <mat-label>Avg Weight (lbs) - OPTIONAL</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="retainedWeight" (input)="_forbidNonNumeric(catchFormGroup.get('retainedWeight')!)">
      </mat-form-field>
    </div>

    <br>

    <div class="row" style="border: 1px solid; border-radius: 5px;">
      <h2 style="margin-bottom: 0%;">Released</h2>
      <mat-form-field>
        <mat-label>Piece Count</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="releasedCount" (input)="_forbidNonNumeric(catchFormGroup.get('releasedCount')!)">
        <mat-error *ngIf="catchFormGroup.get('releasedCount')?.hasError('required') && catchFormGroup.get('releasedCount')?.touched"> Required </mat-error>
        <mat-error *ngIf="catchFormGroup.get('releasedCount')?.hasError('min')"> Piece count cannot be less than 0. </mat-error>
        <mat-error *ngIf="catchFormGroup.get('releasedCount')?.hasError('max')"> Piece count cannot be more than 3000. </mat-error>
      </mat-form-field>

      <mat-form-field style="font-weight: bold;">
        <mat-label>Avg Weight (lbs) - OPTIONAL</mat-label>
        <input matInput
               type="text"
               inputmode="decimal"
               formControlName="releasedWeight"
               (input)="_forbidNonNumeric(catchFormGroup.get('releasedWeight')!)"
               (keyup.enter)="confirmCatch()">
      </mat-form-field>
    </div>

    <br>

    <!-- Delete or submit catch -->
    <div class="row justify-content-between" align="center">
      <div class="col-4">
        <button mat-fab
                class="text-blue-button"
                type="button"
                (click)="dialogRef.close({delete: true})">
          DELETE
        </button>
      </div>

      <div class="col-4">
        <button mat-fab
                class="text-button"
                type="button"
                (click)="confirmCatch()">
          OK
        </button>
      </div>
    </div>

  </div>

</form>
